module.exports = __webpack_public_path__ + "img/card-brand-visa.2b70421a.png";